export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40c6cf800274c002b253c12a33cc2d6e09b287e484&name=revalidateCommunity!'